import { useHistory, useLocation } from "react-router-dom";

const THREAD_ID_KEY = "thread_id";
const COMMENT_ID_KEY = "comment_id";

export const useRemoveCommentUrlParams = () => {
  const history = useHistory();
  const location = useLocation();
  const urlSearchParams = new URLSearchParams(location.search);

  return () => {
    if (urlSearchParams.has(THREAD_ID_KEY) || urlSearchParams.has(COMMENT_ID_KEY)) {
      urlSearchParams.delete(THREAD_ID_KEY);
      urlSearchParams.delete(COMMENT_ID_KEY);
      history.push({ pathname: location.pathname, search: `?${urlSearchParams.toString()}` });
    }
  };
};
